<template>
    <div
        class="f-formInput"
    >
        <input
            v-bind="$attrs"
            ref="formInput"
            class="f-formInput__input"
            :class="{
                [`k-c-input--${status}`]: status,
                [`has-status-${status}`]: status,
                'k-c-input': !showSparkleIcon,
                'f-formInput__input--hasEndIcon': showSparkleIcon,
            }"
            :value="modelValue"
            @input="onInput"
            @change="onChange"
        >
        <SparkleIcon
            v-if="showSparkleIcon"
            class="h-xl absolute right-s top-m"
            data-qa="sparkle icon"
        />
    </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';
import SparkleIcon from '../../../assets/img/icons/sparkle.svg';

const props = withDefaults(defineProps<{
    modelValue: string | number | null;
    modelModifiers?: Record<string, boolean>;
    status?: string;
    showSparkleIcon?: boolean;
}>(), {
    modelModifiers: () => ({}),
    showSparkleIcon: false,
});

const emit = defineEmits(['update:modelValue']);

const onChange = event => (props.modelModifiers.lazy ? emit('update:modelValue', event.target.value) : null);
const onInput = event => (!props.modelModifiers.lazy ? emit('update:modelValue', event.target.value) : null);

const input = useTemplateRef('formInput');

function focusInput() {
    input.value.focus();
}

defineExpose({ focusInput });
</script>

<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>

<style lang="scss">
@use '~@karriereat/global-styles/scss/components/input/index' as input;
@use '~@karriereat/global-styles/scss/settings/spacing';

$input-spacing-icon: 30px;

.f-formInput {
    position: relative;

    &__input {
        &--hasEndIcon {
            // Include global styles class here instead of using it in the html, to be able to overwrite the padding
            @include input.k-c-input;
            text-overflow: ellipsis;
            padding-right: $input-spacing-icon;
        }
    }
}
</style>
